import { Notifier } from "@airbrake/browser";

export const airbrake = new Notifier({
  // @ts-ignore: Defined by Webpack DefinePlugin
  projectId: AIRBRAKE_PROJECT_ID,
  // @ts-ignore: Defined by Webpack DefinePlugin
  projectKey: AIRBRAKE_PROJECT_KEY,
  // @ts-ignore: Defined by Webpack DefinePlugin
  environment: APP_ENV,
});

airbrake.addFilter((notice) => {
  // Disable in these ENVs
  if (["test", "development"].indexOf(notice.environment)) {
    return null;
  } else {
    return notice;
  }
});
